import { format } from "date-fns";

import type { EventField } from "@/components/event-records/event-record-schema";

/**
 * Renders one stored event-record field value for display.
 *
 * Extracted because it existed byte-identically in two places — the record
 * detail route and the print route — and NAU-410's acknowledgement reader needs
 * a third. It also had no test in either copy, which for date parsing is the
 * part most worth pinning.
 */
export function formatFieldValue(field: EventField, value: unknown): string {
  if (value === undefined || value === null || value === "") return "—";
  switch (field.type) {
    case "yes_no":
      return value ? "Yes" : "No";
    case "date":
      return typeof value === "string"
        ? format(new Date(value), "d MMM yyyy")
        : String(value);
    default:
      return String(value);
  }
}
